import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';

export enum EQuestionType
{
    //Unknown = 0,
    MultipleChoice = 1, // options libres, nombre de réponses libre
    UniqueChoice = 2, // options libres, une seule réponse
    Quantity = 3, // saisie de quantité, plusieurs modes possibles
    Text = 4, // saisie de texte libre
    //Smiley = 5, // smileys
    Date = 6, // selection de date
    Year = 7, // selection d'une année
    YesOrNo = 8, // simple oui ou non
    //ZoneSelection = 9, // zone de selection douleur sur plan SVG
    Hour = 10, // Choix d'une heure
    LengthOfTime = 11, // Durée de temps
    //File = 12, // télécharger un fichier
    //Thumbs = 13 // Pouces
}

export enum EDisplayQtyMode
{
    MoreOrLess = 0, // one quantity for each choice
    Slider = 1, // only one value
    UniqueChoice = 2, // multiple choice
    Number // saisie de nombre
}

export enum EDisplayDateMode
{
    UniqueDate = 3, // only one date
    DateInterval = 4  // date interval
}

export enum EDisplayLengthOfTimeMode
{
    Seconde = 0,
    Minute = 1,
    Hour = 2,
    Day = 3,
    Week = 4,
    Month = 5,
    Year = 6
}

declare var _:any;

@Component({
  selector: 'app-question-editor',
  templateUrl: './question-editor.component.html',
  styleUrls: ['./question-editor.component.scss']
})
export class QuestionEditorComponent implements OnInit {

  constructor() {
  }

  @Input() question:any;  
  @Input() questionView:any;  
  @Input() graph:any;

  private allowCustomizeOptionsTypes = [1, 2, 9];

  private textOption = ['Texte'];

  private sliderOption = ['Slider'];

  private numberOption = ['Nombre'];

  private yearOption = ['Année'];

  private hourOption = ['Heure'];

  private lengthOfTimeOption = ['Durée de temps'];

  private dateOption = ['Date'];

  private fileOption = ['Fichier'];
  
  private smileyOptions = [
    "1",
    "3",
    "5",
    "7",
    "9"
];

private thumbsOptions = [
    "1",
    "2",
    "3",
    "4",
    "5"
];

private yesNoOption = [
    'Oui',
    'Non'
];

  private defaultOptionsForTypes = {
      5: this.smileyOptions,
      4: this.textOption,
      8: this.yesNoOption,
      7: this.yearOption,
      6: this.dateOption,
      10: this.hourOption,
      11: this.lengthOfTimeOption,
      12: this.fileOption,
      13: this.thumbsOptions
  };

  public EQuestionType = EQuestionType;
  public EDisplayQtyMode = EDisplayQtyMode;
  public question_types_property;
  public date_modes_property;
  public quantity_modes_property;

  question_types() : Array<any> {
    let myEnum = [];
    let objectEnum = Object.keys(EQuestionType);
    const values = objectEnum.slice( 0 , objectEnum.length / 2 );
    const keys = objectEnum.slice( objectEnum.length / 2 );

    for (let i = 0 ; i < objectEnum.length/2 ; i++ ) {
      myEnum.push( { key: keys[i], value: values[i] } ); 
    }
    return myEnum;
  }

  date_modes() : Array<any> {
    let myEnum = [];
    let objectEnum = Object.keys(EDisplayDateMode);
    const values = objectEnum.slice( 0 , objectEnum.length / 2 );
    const keys = objectEnum.slice( objectEnum.length / 2 );

    for (let i = 0 ; i < objectEnum.length/2 ; i++ ) {
      myEnum.push( { key: keys[i], value: values[i] } ); 
    }
    return myEnum;
  }

  quantity_modes() : Array<any> {
    let myEnum = [];
    let objectEnum = Object.keys(EDisplayQtyMode);
    const values = objectEnum.slice( 0 , objectEnum.length / 2 );
    const keys = objectEnum.slice( objectEnum.length / 2 );

    for (let i = 0 ; i < objectEnum.length/2 ; i++ ) {
      myEnum.push( { key: keys[i], value: values[i] } ); 
    }
    return myEnum;
  }


  ngOnInit(): void {
    this.date_modes_property = this.date_modes();
    this.question_types_property = this.question_types();
    this.quantity_modes_property = this.quantity_modes();
  }

  sortBy(prop: string) {
    if (this.question.options != undefined)
      return this.question.options.sort((a:any, b:any) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
    return [];
  }

  /**
   * Permet de diffuser la modification d'une propriété à la vue pour modifier l'apparence dans le canvas
   * @param changes la nouvelle valeur
   * @param propName le nom du champ modifié
   */
  modelChanged(changes: any, propName: string){
    if (propName === 'display'){
      // modification du type d'affichage de quantité
        this.removeAllOptions();

        if (parseInt(changes) === 1) {
            this.question.options = this.sliderOption.map(function (opt) { return { id: _.uniqueId('option-'), text: opt }; });
        }

        if (parseInt(changes) === 3) {
          this.question.options = this.numberOption.map(function (opt) { return { id: _.uniqueId('option-'), text: opt }; });
        }

        if (parseInt(changes) === 2 || parseInt(changes) === 1 || parseInt(changes) === 3) {
            if (!this.question.minValue) {
              this.question.minValue = 1;
            }

            if (!this.question.maxValue) {
              this.question.maxValue = 5;
            }
        }

        if (parseInt(changes) === 2) {
          //this.changedMinOrMaxValue();
        }

        if (parseInt(changes) === 0 || parseInt(changes) == 2) {
            //this.newOption();
        }
        if (this.questionView.model.attributes.options.length !== 0 || this.question.options.length !== 0){
          this.setOptions(this.question.options);
        }
    }
    this.questionView.model.set(propName, changes);
  }

  isNewOptionAllowed():boolean{
    var typequestion = parseInt(this.question.typequestion);
    var typeAffichage = parseInt(this.question.display);
    return this.allowCustomizeOptionsTypes.indexOf(typequestion) !== -1 
      || (typequestion == 3 && typeAffichage == 0) 
      || (typequestion == 3 && typeAffichage == 2);
  }

  newOption(){
    if (this.question.options == undefined || this.question.options == null)
      this.question.options = [];

    this.question.options.push({ id: _.uniqueId('option-'), text: '' });
    this.questionView.model.set('options', this.question.options);
  }

  removeOption(opt: any){
    this.question.options.splice(this.question.options.indexOf(opt), 1);
    this.questionView.model.set('options', this.question.options);
  }

  removeAllOptions(){
    this.question.options.splice(0,this.question.options.length);
    this.questionView.model.set('options', this.question.options);
  }

  questionTypeChanged(event: any) {
    var _this = this;
    if (event && this.question.typequestion && this.question.typequestion != event) {
      // supression de toutes les options dans les cas suivants :
      //      - le type précédent était un type à "options figées"
      //      - new options are customizable but not previous
      //      - new type is smiley
      
      // ancien type = quantité : on repasse les modes d'affichage / min / max à leur valeur par défaut
      if (this.question.typequestion == EQuestionType.Date.valueOf()) {
        this.question.display = 0;
        this.question.minValue = 0;
        this.question.maxValue = 0;
        this.question.dateMode = 0;
      }

      this.question.userVariableId = null;

      // !!!!! GERER LE CAS DE LA QUANTITE DISPLAY 0 !!!!!

      // si l'ancien type de question était à "options manuelles" et que le nouveau type ne l'est pas, on supprime toutes les options 
      if (this.allowCustomizeOptionsTypes.indexOf(parseInt(this.question.typequestion)) !== -1 &&
        this.allowCustomizeOptionsTypes.indexOf(parseInt(event)) === -1 ){
          this.removeAllOptions();
      }

      // si l'ancien type de question n'était pas à "options manuelles" et que le nouveau type l'est, on supprime toutes les options 
      if (this.allowCustomizeOptionsTypes.indexOf(parseInt(this.question.typequestion)) === -1 &&
        this.allowCustomizeOptionsTypes.indexOf(parseInt(event)) !== -1 ){
        this.removeAllOptions();
      }

      // récupération des options par défaut du type de question
      if (this.defaultOptionsForTypes[parseInt(event)]) {
          var defaults = this.defaultOptionsForTypes[parseInt(event)];
          var newOptions = defaults.map(function (o) {
              return { id: _.uniqueId('option-'), text: o };
          });
          this.question.options = newOptions;
      }

      if (parseInt(event) === 3) {
          // type quantité choisi : le mode d'affichage par défaut est +/-
          this.question.display = 0;
      }
      if (parseInt(event) === 6) {
          if (this.question.dateMode != 3 && this.question.dateMode != 4)
              // if new type is date, the default display mode must be unique date
              this.question.dateMode = 3;
      }

      // if new type is customizable add a new option if previous was not customizable and not a slider quantity
      if (this.allowCustomizeOptionsTypes.indexOf(event) !== -1 && (this.allowCustomizeOptionsTypes.indexOf(this.question.typequestion) === -1 && (this.question.typequestion !== 3 || this.question.display !== 0))) {
          //this.newOption();
      }

      var allLinks = this.graph.getLinks();
      var links = allLinks.filter(function (cell) { return cell.attributes.source.id == _this.question.id; });

      if (this.allowCustomizeOptionsTypes.indexOf(event) !== -1 && this.question.typequestion === 3) {
          links.map(function (l:any) {
              l.attributes.condition = null;
              l.removeLabel(0);
          });
      }
      else if (this.allowCustomizeOptionsTypes.indexOf(this.question.typequestion) !== -1 && event === 3) {
          links.map(function (l: any) {
              _this.handleLinkLabel(l);
          });
      }
    }
    
    this.setOptions(this.question.options);
  }

  setOptions(newOptions: any){
    let cloned = newOptions.map(x => Object.assign({}, x));
    this.questionView.model.set('options', cloned);
  }

  handleLinkLabel(link:any) {

  }
}
